import { Message } from 'view-design'
import qs from 'qs'
import Axios from 'axios'

const env = process.env
let token = window.localStorage.getItem('token') || ''
let userName = window.localStorage.getItem('userName') || ''
let jurisdiction = JSON.parse(window.localStorage.getItem('jurisdiction')) || []
const urlList = [
  'extscreenapi/plugin/hili/esPluginMac/list',
  'extscreenapi/plugin/hili/esPluginMac/delete',
  'extscreenapi/plugin/hili/esPluginMac/edit',
  'extscreenapi/plugin/hili/esPluginMac/add',
  'extscreenapi/plugin/hili/esPluginVersionVerify/batchVerify',
  'extscreenapi/plugin/hili/esPluginVersionVerify/setMacs',
  'extscreenapi/plugin/hili/esPluginVersionVerify/verify',
  'extscreenapi/plugin/hili/esPluginVerify/verify',
  'extscreenapi/plugin/hili/esAppPluginApk/edit',
  'extscreenapi/plugin/hili/esPluginVerify/list',
  'extscreenapi/plugin/hili/esApkPluginApk/add',
  'extscreenapi/plugin/hili/esApkPluginApk/edit',
  'extscreenapi/plugin/hili/cardGroup/add',
  'extscreenapi/plugin/hili/cardGroup/edit',
  'esApkPlugin/add',
  'getUsernamesByKey',
  'extscreenapi/plugin/hili/esAppPluginApk/add',
  'extscreenapi/plugin/hili/esApkPlugin/edit',
  'extscreenapi/plugin/hili/esAppPlugin/editUpload',
  'extscreenapi/plugin/hili/esApkPlugin/editUpload',
  // 'extscreenapi/plugin/hili/esAppPluginTest/list',
  // 'extscreenapi/plugin/hili/esAppPluginTest/editUpload',
  'esAppPlugin/add',
  'extscreenapi/plugin/hili/esApkPluginTest/editUpload',
  'extscreenapi/plugin/hili/esAppPlugin/edit',
  'extscreenapi/plugin/hili/card/add',
  'extscreenapi/plugin/hili/card/edit'
]
const userpermissionList = [
  'changePassword',
  'login',
  'account',
  'role/add',
  'role/edit',
  'user/list',
  'user/add',
  'user/edit',
  'user/auditList',
  'extscreenapi/plugin/hili/esPluginVerify/progress',
  'extscreenapi/plugin/hili/esPluginVersionVerify/progress',
  'extscreenapi/plugin/hili/esAppPluginTest/editUpload',
  'v2/es/audit/app/progress',
  'v2/es/audit/appver/progress',
  'v2/es/appvertest/syncProd',
  'extscreenapi/plugin/hili/esAppPluginApkTest/syncProd',
  'extscreenapi/plugin/hili/esApkPluginApkTest/syncProd'
]
// const list = [
//   '/v2/es/audit/appver/batch',
//   '/v2/es/app/vers/batch',
//   '/v2/es/app',
//   '/store/upload',
//   '/tvpver/add',
//   '/upload/asset',
//   '/upload/licence',
//   '/audit/companys',
//   '/zero/arrange',
//   '/apk/build',
//   '/apk/task',
//   '/tvp/add',
//   '/tvp/edit',
//   '/file',
//   '/apptest/add',
//   '/apptest/del',
//   '/apptest/list',
//   '/apptest/get',
//   '/apptest/put',
//   '/appvertest/add'
// ]
// 设置baseURL
Axios.defaults.baseURL = process.env.API_HOST
// 设置token值
Axios.defaults.headers.common['satoken'] = token
// 请求头
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 添加请求拦截器
Axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if (userpermissionList.includes(config.url)) {
    Axios.defaults.headers.post['Content-Type'] = 'application/json'
    return config
  }
  // if (config.url.indexOf('login') !== -1 || config.url.indexOf('account') !== -1 || config.url.indexOf('role/add') !== -1 || config.url.indexOf('role/edit') !== -1) {
  //   Axios.defaults.headers.post['Content-Type'] = 'application/json'
  //   return config
  // }
  if (filterUrl(config.url)) {
    Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    return config
  }
  // if (config.url.indexOf('esApkPluginTest/editUpload') !== -1 || config.url.indexOf('esAppPluginTest/editUpload') !== -1 || config.url.indexOf('esPluginMac/list') !== -1 || config.url.indexOf('esPluginMac/delete') !== -1 || config.url.indexOf('esPluginMac/edit') !== -1 || config.url.indexOf('esPluginMac/add') !== -1 || config.url.indexOf('esPluginVersionVerify/batchVerify') !== -1 || config.url.indexOf('esPluginVersionVerify/setMacs') !== -1 || config.url.indexOf('esPluginVersionVerify/verify') !== -1 || config.url.indexOf('esPluginVerify/verify') !== -1 || config.url.indexOf('esPluginVerify/list') !== -1 || config.url.indexOf('esApkPluginApk/add') !== -1 || config.url.indexOf('esApkPluginApk/edit') !== -1 || config.url.indexOf('cardGroup/add') !== -1 || config.url.indexOf('cardGroup/edit') !== -1 || config.url.indexOf('esApkPlugin/add') !== -1 || config.url.indexOf('esApkPlugin/edit') !== -1 || config.url.indexOf('esAppPluginApk/add') !== -1 || config.url.indexOf('esAppPluginApk/edit') !== -1 || config.url.indexOf('esAppPlugin/add') !== -1 || config.url.indexOf('esAppPlugin/editUpload') !== -1 || config.url.indexOf('esApkPlugin/editUpload') !== -1 || config.url.indexOf('esAppPlugin/edit') !== -1 || config.url.indexOf('card/add') !== -1 || config.url.indexOf('card/edit') !== -1) {
  //   Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  //   return config
  // }
  setTimeout(() => {
    if (config.url.indexOf('/v1/tvpver/add') !== -1 || config.url.indexOf('/v2/es/appvertest/add') !== -1 || config.url.indexOf('esApkPlugin/uploadApkFile') !== -1 || config.url.indexOf('esAppPlugin/uploadZipFile') !== -1 || config.url.indexOf('esApkPluginTest/uploadApkFile') !== -1 || config.url.indexOf('esAppPluginTest/uploadZipFile') !== -1) {
      Axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
      return config
    }
    if (config.method !== 'get' && config.method !== 'delete' && config.url.indexOf('apptest/add') === -1 && config.url.indexOf('/v2/es/audit/appver/batch') === -1 && config.url.indexOf('/v2/es/app/vers/batch') === -1 && config.url.indexOf('/v2/es/app') === -1 && config.url.indexOf('/store/upload') === -1 && config.url.indexOf('/tvpver/add') === -1 && config.url.indexOf('/upload/asset') === -1 && config.url.indexOf('/upload/licence') === -1 && config.url.indexOf('/audit/companys') === -1 && config.url.indexOf('/zero/arrange') === -1 && config.url.indexOf('/apk/build') === -1 && config.url.indexOf('/apk/task') === -1 && config.url.indexOf('/tvp/add') === -1 && config.url.indexOf('/tvp/edit') === -1 && config.url.indexOf('/file') === -1) {
      config.data = qs.stringify(config.data)
    }
  }, 50)
  // if (config.method !== 'get' && config.method !== 'delete' && !list.includes(config.url)) {
  //   console.log(config.data)
  //   config.data = qs.stringify(config.data)
  // }
  return config
}, function (error) {
  // 对请求错误做些什么
  console.log('错误的传参')
  return Promise.reject(error)
})
function filterUrl (url) {
  let flag = false
  urlList.map(item => {
    if (item.indexOf(url) !== -1) {
      flag = true
    }
  })
  setTimeout(() => {
    return flag
  })
  // console.log(flag)
  // return flag
}

// 添加响应拦截器
// Axios.interceptors.response.use(function (response) {
//   // 对响应数据做点什么
//   return response;
// }, function (error) {
//   // 对响应错误做点什么
//   return Promise.reject(error);
// });

function request (data) {
  return new Promise((resolve, reject) => {
    Axios({
      method: data.method,
      url: data.url,
      params: data.params,
      data: data.data,
      headers: data.headers
    }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data || res)
      } else if (res.data.code === 401) {
        reloadHome()
        // window.localStorage.removeItem('token')
        // window.localStorage.removeItem('username')
        // window.localStorage.removeItem('userId')
        // window.localStorage.removeItem('role_id')
        // location.reload()
      } else if (res.data.code === 400) {
        resolve(res.data || res)
      } else if (res.data.code === 500) {
        if (data.url === 'role/edit') {
          resolve(res.data || res)
        } else {
          resolve(res.data)
        }
      } else {
        if (data.url === '/v2/es/store/app' || data.url === 'extscreenapi/plugin/hili/esApkPlugin/editUpload' || data.url === 'extscreenapi/plugin/hili/esAppPlugin/editUpload' || data.url === '/v2/es/store/upload' || data.url === '/v2/es/app' || data.url === '/v2/es/audit/app' || data.url === '/v2/es/audit/appver' || data.url === '/v2/es/account/qualification' || data.url === '/v2/es/audit/developer' || data.url === '/v2/es/audit/payment' || data.url === '/v2/es/audit/company') {
          resolve(res.data)
        } else {
          reject(res.data.msg)
        }
      }
    }).catch(error => {
      console.log('请求失败')
      console.log(error)
      Message.error('请求失败')
    })
  })
}
function requestUpload (data) {
  return new Promise((resolve, reject) => {
    Axios({
      method: data.method,
      url: data.url,
      params: data.params,
      data: data.data,
      headers: data.headers,
      cancelToken: data.cancelToken,
      onUploadProgress: data.onUploadProgress
    }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else if (res.data.code === 400) {
        // Message.error(res.data.message)
        resolve(res.data)
      } else if (res.data.code === 401) {
        reloadHome()
        // window.localStorage.removeItem('token')
        // window.localStorage.removeItem('username')
        // window.localStorage.removeItem('userId')
        // window.localStorage.removeItem('role_id')
        // location.reload()
      } else if (res.data.code === 500) {
        resolve(res.data)
      } else {
        if (data.url === 'esAppPluginTest/uploadZipFile') {
          resolve(res.data)
        } else {
          reject(res.data.msg)
        }
      }
    }).catch(error => {
      console.log(error)
      Message.error('请求失败')
    })
  })
}
function requestcms (data) {
  return new Promise((resolve, reject) => {
    Axios({
      method: data.method,
      url: data.url,
      params: JSON.stringify(data.params),
      data: JSON.stringify(data.data),
      headers: data.headers
    }).then(res => {
      if (res.data.code === 0) {
        resolve(res.data)
      } else if (res.data.code === 401) {
        reloadHome()
        // window.localStorage.removeItem('token')
        // window.localStorage.removeItem('username')
        // window.localStorage.removeItem('userId')
        // window.localStorage.removeItem('role_id')
        // location.reload()
      } else {
        reject(res.data.msg)
      }
    }).catch(error => {
      console.log('请求失败')
      console.log(error)
      Message.error('请求失败')
    })
  })
}
function reloadHome () {
  window.localStorage.removeItem('token')
  window.localStorage.removeItem('username')
  window.localStorage.removeItem('userId')
  window.localStorage.removeItem('role_id')
  location.reload()
}

export default {
  env,
  token,
  userName,
  jurisdiction,
  config: {},
  request,
  requestUpload,
  requestcms
}



// WEBPACK FOOTER //
// ./src/https.js